<template>
  <div class="bg-white p-4 rounded-lg mt-4">
    <div class="grid grid-cols-2 gap-y-6 gap-x-4 text-textPrimary">
      <div class="text-left">
        <h3 class="text-sm font-bold">Data da solicitação</h3>
        <p class="mt-1 text-sm">{{ formattedRequestDate }}</p>
      </div>

      <div class="text-left">
        <h3 class="text-sm font-bold">ID da solicitação</h3>
        <p class="mt-1 text-sm">{{ formattedRequestId }}</p>
      </div>

      <div class="text-left">
        <h3 class="text-sm font-bold">Prejuízo total</h3>
        <p class="mt-1 text-sm text-negative">{{ formattedTotalLoss }}</p>
      </div>

      <div class="text-left">
        <h3 class="text-sm font-bold">Solicitante</h3>
        <p class="mt-1 text-sm">{{ requesterName }}</p>
      </div>
    </div>

    <div
      v-if="approvedExceptions && approvedExceptions.length > 0"
      class="text-left mt-6 text-textPrimary"
    >
      <h3 class="text-sm font-bold">Excepcionalidades aprovadas</h3>
      <div class="mt-2 flex flex-wrap gap-2">
        <span
          v-for="exception in approvedExceptions"
          :key="exception"
          class="px-1 py-1 text-sm text-slate-700 bg-neutral-100 border border-neutral-500 rounded-md"
        >
          {{ exception }}
        </span>
      </div>
    </div>

    <div
      v-if="rejectedExceptions && rejectedExceptions.length > 0"
      class="text-left mt-6 text-textPrimary"
    >
      <h3 class="text-sm font-bold">Excepcionalidades rejeitadas</h3>
      <div class="mt-2 flex flex-wrap gap-2">
        <span
          v-for="exception in rejectedExceptions"
          :key="exception"
          class="px-1 py-1 text-sm text-slate-700 bg-neutral-100 border border-neutral-500 rounded-md"
        >
          {{ exception }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { format, parseISO } from 'date-fns'

const props = defineProps<{
  requestDate: string
  requestId: number | string
  totalLoss: number
  requesterName: string
  approvedExceptions: string[]
  rejectedExceptions: string[]
}>()

const formattedRequestDate = computed(() => {
  if (!props.requestDate) return 'N/A'

  try {
    const date = parseISO(props.requestDate)
    return format(date, "dd/MM/yyyy 'às' HH:mm")
  } catch (error) {
    return 'Data inválida'
  }
})

const formattedRequestId = computed(() => `#${props.requestId}`)

const formattedTotalLoss = computed(() => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(props.totalLoss)
})
</script>
